export default async function GetUser({username}) {

    const url = "/LoginPage/procesos/getUser.php";
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            username
        }),
    })
    
    if(res.status == 200){
        return await res.json()
    }else{
        return "Error obteniendo los datos"
    }
}